// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"a1b28cb4","496":"47c1cca7"}[chunkId] + ".chunk.js";
};